/**
 * Concurrent HTTP + SSE connection tracker.
 * Flip ENABLED to true when hunting OkHttp / connection-pool stalls.
 *
 * Call sites stay hot; when disabled this is a no-op (no logs, no work).
 */
const ENABLED = __DEV__ && false;

let httpInFlight = 0;
let sseOpen = 0;

export const netDebug = {
  get enabled() {
    return ENABLED;
  },

  httpStart(label: string) {
    if (!ENABLED) return;
    httpInFlight += 1;
    console.log(
      `[net] HTTP+ ${label} | http=${httpInFlight} sse=${sseOpen} total=${httpInFlight + sseOpen}`,
    );
  },

  httpEnd(label: string) {
    if (!ENABLED) return;
    httpInFlight = Math.max(0, httpInFlight - 1);
    console.log(
      `[net] HTTP- ${label} | http=${httpInFlight} sse=${sseOpen} total=${httpInFlight + sseOpen}`,
    );
  },

  sseOpen(label: string) {
    if (!ENABLED) return;
    sseOpen += 1;
    console.log(
      `[net] SSE+  ${label} | http=${httpInFlight} sse=${sseOpen} total=${httpInFlight + sseOpen}`,
    );
  },

  sseClose(label: string) {
    if (!ENABLED) return;
    sseOpen = Math.max(0, sseOpen - 1);
    console.log(
      `[net] SSE-  ${label} | http=${httpInFlight} sse=${sseOpen} total=${httpInFlight + sseOpen}`,
    );
  },

  snapshot() {
    return { http: httpInFlight, sse: sseOpen, total: httpInFlight + sseOpen };
  },

  /** Log a labeled snapshot when enabled. */
  logSnapshot(label: string) {
    if (!ENABLED) return;
    console.log(`[net] ${label}`, this.snapshot());
  },

  /**
   * Start a pending-watchdog for a long request. Returns a clear() fn.
   * No-op when disabled.
   */
  watchPending(label: string, intervalMs = 3000): () => void {
    if (!ENABLED) return () => {};
    const startedAt = Date.now();
    const id = setInterval(() => {
      console.log(
        `[net] STILL PENDING ${label} ${Date.now() - startedAt}ms`,
        this.snapshot(),
      );
    }, intervalMs);
    return () => clearInterval(id);
  },
};
